"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseByteRangeHeader = parseByteRangeHeader;
/**
 * Parses a single `bytes=` Range header against a known size: the platform
 * delivery of blobs and attachments and the local server of the StreamKit read
 * a range with this one function.
 */
function parseByteRangeHeader(rangeHeader, size) {
    if (rangeHeader === undefined) {
        return { kind: 'full' };
    }
    if (Array.isArray(rangeHeader) || size <= 0) {
        return { kind: 'invalid' };
    }
    const match = /^bytes=(\d*)-(\d*)$/.exec(rangeHeader.trim());
    if (!match) {
        return { kind: 'invalid' };
    }
    const [, rawStart, rawEnd] = match;
    if (!rawStart && !rawEnd) {
        return { kind: 'invalid' };
    }
    if (!rawStart) {
        const suffixLength = Number(rawEnd);
        if (!Number.isSafeInteger(suffixLength) || suffixLength <= 0) {
            return { kind: 'invalid' };
        }
        const start = Math.max(size - suffixLength, 0);
        const end = size - 1;
        return {
            kind: 'range',
            start,
            end,
            contentLength: end - start + 1,
        };
    }
    const start = Number(rawStart);
    const requestedEnd = rawEnd ? Number(rawEnd) : size - 1;
    if (!Number.isSafeInteger(start) ||
        !Number.isSafeInteger(requestedEnd) ||
        start < 0 ||
        requestedEnd < start ||
        start >= size) {
        return { kind: 'invalid' };
    }
    const end = Math.min(requestedEnd, size - 1);
    return {
        kind: 'range',
        start,
        end,
        contentLength: end - start + 1,
    };
}
